<template>
  <AppHeader :action="{text: 'Add', route: 'CreateGroup'}">All Groups</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="responsive-table">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>ID</th>
            <th>Name</th>
            <th>Customers</th>
            <th>Delivery Person</th>
          </tr>
        </thead>
        <tbody ref="sortableTable">

          <tr v-for="item in data.groups" :key="item.id" :id="item.id">
            <td class="py-2 sortable-handle"><i class="px-3 ion-md-menu"></i></td>
            <td>#{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.customers_count }}</td>
            <td>
              <select @change="updateDeliveryPerson($event.target.value, item)" :value="item.delivery_person_id" class="px-2 text-sm text-gray rounded-md">
                <option disabled hidden selected value="">-- SET DELIVERY PERSON --</option>
                <option v-for="dp in delivery_persons" :value="dp.id" :key="dp.id">{{ dp.name }}</option>
              </select>
            </td>
          </tr>

        </tbody>
      </table>
    </div>

    <div class="mt-5 text-center">
      <button class="px-3 py-2 text-sm leading-none text-gray-600 uppercase rounded-full bg-slate-300" @click="updateOrder">Update Order</button>
    </div>

  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import Sortable from 'sortablejs';

export default {
  name: 'Groups',
  mixins: [ mixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      state: 'loading',
      groups: [],
      delivery_persons: [],
      sortable: null,
    }
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'groups', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.data = resp.data;
          this.delivery_persons = resp.data.delivery_persons;

          this.$nextTick(() => {
            this.sortable = new Sortable(this.$refs.sortableTable, {
              handle: '.sortable-handle',
              chosenClass: 'bg-green-200',
              onEnd: (e) => {
                if (e.oldIndex != e.newIndex) e.item.classList.add('bg-amber-200');
              },
            });
          });
        }
      });
    },

    updateDeliveryPerson(selectedDp, group) {
      if (selectedDp == group.delivery_person_id) return;

      this.state = 'loading';
      this.request('POST', 'groups/' + group.id + '/set-delivery-person', {delivery_person_id: selectedDp}, (resp) => {
        this.state = 'idle';

        if (resp.success) {
          this.getData();
        } else {
          alert(resp.message);
        }
      });
    },

    updateGroup() {
      if (!confirm('Are you sure?')) return;

      this.state = 'loading';
      this.request('POST', 'groups/' + this.form.id, this.form, (resp) => {
        this.state = 'idle';
        alert(resp.message);
        if (resp.success) this.form = {};
      });
    },

    updateOrder() {
      if (!confirm('Are you sure?')) return;

      let data = Array.from(this.$refs.sortableTable.children).map(c => Number(c.id));

      this.request('POST', 'groups/order', {groups: data}, (resp) => {
        if (resp.success) this.getData();
      });
    },
  },

  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
    else this.getData();
  }
}
</script>
